export default {
  //联系我们
  contact: resolve => {
    require.ensure([], () => {
      resolve(require('@/views/contact/list.vue'));
    }, '/modules/contact/list');
  },
  contactBanner: resolve => {
    require.ensure([], () => {
      resolve(require('@/views/contact/contact-banner.vue'));
    }, '/modules/contact/contact-banner');
  },
  contactInformation: resolve => {
    require.ensure([], () => {
      resolve(require('@/views/contact/contact-information.vue'));
    }, '/modules/contact/contact-information');
  }
}



// WEBPACK FOOTER //
// ./src/router/modules/contact.js